

/* TRANSLATIONS */
// addTranslations :: VGNavigationTranslator -> void
const addTranslations = VGNavigationTranslator => {

  const translator = VGNavigationTranslator.prototype;

  /**
   * @private
   * @name cLanguageMap
   * @memberof VGNavigationTranslator#
   * @description
   * Map of language strings to index into: cActionStringTable, cNextActionStringTable, cTimeStringTable, cStringTable.
   * These tables keep exactly the same structure as the VisioMove SDK.
   */
  translator.cLanguageMap = {
    en: 0,
    et: 1,
    fi: 2,
    nb: 3,
    sv: 4,
    ru: 5,
  };

  // You can use a table like this to handle multiple languages.
  // This text is in UTF8
  /**
   * @private
   * @name cActionStringTable
   * @memberof VGNavigationTranslator#
   * @description
   * Maneuver to action string including tokens to be replaced by certain keywords
   * @see VGNavigationTranslator#_replaceTokens
   */
  translator.cActionStringTable = [
    [
      '<unknown>', // eVgManeuverTypeUnknown
      'Go straight',
      'Turn gentle right',
      'Turn gentle left',
      'Turn right',
      'Turn left',
      'Turn sharp right',
      'Turn sharp left',
      'Make right U-turn',
      'Make left U-turn',
      'Start',
      'You have arrived',
      'Go up to floor %L',
      'Go down to floor %L',
      'Use transportation mode %M',
      'Change Buildings',
      'Stop' // in 1.7.17 it said "waypoint #"
    ],
    [
      '<tundmatu>',
      'Mine otse edasi',
      'Hoia pisut paremale',
      'Hoia pisut vasakule',
      'Pööra paremale',
      'Pööra vasakule',
      'Pööra järsult paremale',
      'Pööra järsult vasakule',
      'Pööra tagasi paremale',
      'Pööra tagasi vasakule',
      'Alusta',
      'Jõudsid sihtkohta',
      'Mine korrusele %L',
      'Mine korrusele %L',
      'Kasuta %M',
      'Mine teise majja',
      'Jää seisma'
    ],
    [
      '<outo>', // eVgManeuverTypeUnknown
      'Kulje suoraan eteenpäin',
      'Käänny loivasti oikealle',
      'Käänny loivasti vasemmalle',
      'Käänny oikealle',
      'Käänny vasemmalle',
      'Käänny jyrkästi oikealle',
      'Käänny jyrkästi vasemmalle',
      'Käänny takaisin  oikealle',
      'Käänny takaisin vasemmalle',
      'Aloita',
      'Olet määränpäässä',
      'Siirry kerrokseen %L',
      'Siirry kerrokseen %L',
      'Käytä %M',
      'Siirry toiseen rakennukseen',
      'Pysähdy'
    ],    
    [
      '<ukjent>',
      'Gå rett',
      'Sving forsiktig til høyre',
      'Sving forsiktig til venstre',
      'Sving til høyre',
      'Sving til venstre',
      'Sving skarpt til høyre',
      'Sving skarpt til venstre',
      'Gjør U-sving til høyre',
      'Gjør U-sving til venstre',
      'Start',
      'Du har ankommet',
      'Gå opp til etasje %L', 
      'Gå ned til etasje %L',
      'Bruk transportmodus %M',
      'Endre bygninger',
      'Stopp' 
    ],
    [
      '<unknown>',
      'Gå rakt',
      'Vänd dig försöktigt till höger',
      'Vänd dig försöktigt till vänster',
      'Vänd dig till höger',
      'Vänd dig till vänster',
      'Vänd dig skarpt till höger',
      'Vänd dig skarpt till vänster',
      'Gör en U-sväng till höger',
      'Gör en U-sväng till vänster',
      'Starta',
      'Du har anlänt',
      'Gå upp till våning %L',
      'Gå ner till våning %L',
      'Använd transportsätt %M',
      'Byt byggnad',
      'Stanna'
    ],
    [
      '<не определено>',
      'Идите прямо',
      'Плавно поверните направо',
      'Плавно поверните налево',
      'Поверните направо',
      'Поверните налево',
      'Резко поверните направо',
      'Резко поверните налево',
      'Поверните назад вправо',
      'Поверните назад влево',
      'Начать',
      'Вы прибудете в пункт вашего назначения',
      'Перейдите на %L этаж',
      'Перейдите на %L этаж',
      'Используйте %M',
      'Перейдите в другое здание',
      'Остановитесь'
    ]
  ];

  /**
   * @private
   * @name cNextActionStringTable
   * @memberof VGNavigationTranslator#
   * @description
   * Maneuver to next action string including tokens to be replaced by certain keywords
   * @see VGNavigationTranslator#_replaceTokens
   */
  translator.cNextActionStringTable = [
    [
      '<unknown>', // eVgManeuverTypeUnknown
      'go straight',
      'turn gentle right',
      'turn gentle left',
      'turn right',
      'turn left',
      'turn sharp right',
      'turn sharp left',
      'make right U-turn',
      'make left U-turn',
      'start',
      'you have arrived',
      'go up',
      'go down',
      'change transportation mode: %M',
      'change buildings', // Layer change, it could be buildings, zone, inside/outside....
      'stop' // eVgManeuverTypeWaypoint
    ],
    [
      '<tundmatu>',
      'mine otse edasi',
      'hoia pisut paremale',
      'hoia pisut vasakule',
      'pööra paremale',
      'pööra vasakule',
      'pööra järsult paremale',
      'pööra järsult vasakule',
      'pööra tagasi paremale',
      'pööra tagasi vasakule',
      'alusta',
      'jõudsid sihtkohta',
      'mine korrusele %L',
      'mine korrusele %L',
      'kasuta %M',
      'mine teise majja',
      'jää seisma'
    ],
    [
      '<outo>', // eVgManeuverTypeUnknown
      'kulje suoraan eteenpäin',
      'käänny loivasti oikealle',
      'käänny loivasti vasemmalle',
      'käänny oikealle',
      'käänny vasemmalle',
      'käänny jyrkästi oikealle',
      'käänny jyrkästi vasemmalle',
      'käänny takaisin  oikealle',
      'käänny takaisin vasemmalle',
      'aloita',
      'olet määränpäässä',
      'siirry kerrokseen %L',
      'siirry kerrokseen %L',
      'käytä %M',
      'siirry toiseen rakennukseen',
      'pysähdy'
    ],
    [
      '<ukjent>',
      'gå rett',
      'sving forsiktig til høyre',
      'sving forsiktig til venstre',
      'sving til høyre',
      'sving til venstre',
      'sving skarpt til høyre',
      'sving skarpt til venstre',
      'gjør U-sving til høyre',
      'gjør U-sving til venstre',
      'start',
      'du har ankommet',
      'gå opp til etasje %L', // <- Hvis retningen ikke passer til oversettelsen, kan den droppes
      'gå ned til etasje %L', // <- samme
      'bruk transportmodus %M',
      'endre bygninger',
      'stopp' 
    ],
    [
      '<unknown>',
      'gå rakt',
      'vänd dig försöktigt till höger',
      'vänd dig försöktigt till vänster',
      'vänd dig till höger',
      'vänd dig till vänster',
      'vänd dig skarpt till höger',
      'vänd dig skarpt till vänster',
      'gör en U-sväng till höger',
      'gör en U-sväng till vänster',
      'starta',
      'du har anlänt',
      'gå upp till våning %L',
      'gå ner till våning %L',
      'använd transportsätt %M',
      'byt byggnad',
      'stanna'
    ],
    [
      '<не определено>',
      'идите прямо',
      'плавно поверните направо',
      'плавно поверните налево',
      'поверните направо',
      'поверните налево',
      'резко оверните направо',
      'резко поверните налево',
      'поверните назад вправо',
      'поверните назад влево',
      'начать',
      'вы прибудете в пункт вашего назначения',
      'перейдите на %L этаж',
      'перейдите на %L этаж',
      'используйте %M',
      'перейдите в другое здание',
      'остановитесь'
    ]
  ];

  /**
   * @private
   * @name cTimeStringTable
   * @memberof VGNavigationTranslator#
   * @description
   * time under minute, around a minute, X number of minutes
   * @see VGNavigationTranslator#_replaceTokens
   */
  translator.cTimeStringTable = [
    ['a few seconds', 'about a minute', 'about %d minutes'],
    ['kiiresti', 'umbes 1 minut', 'umbes %d minutit'],
    ['hetki', 'noin minuutti', 'noin %d minuuttia'],
    [
      'noen få sekunder', 
      'omtrent et minutt', 
      'omtrent %d minutter'
    ],
    ['några sekunder', 'cirka en minut', 'ungefär %d minuter'],
    ['несколько секунд', 'около минуты', 'около %d мин.']
  ];

  /* [cNumLanguages][eStringCount]*/
  /**
   * @private
   * @name cStringTable
   * @memberof VGNavigationTranslator#
   * @description
   * translation of some keywords
   */
  translator.cStringTable = [
    [
      ' for ',
      ' then ',
      ' and ',
      ' near %S',
      ' using ',
      'the stairway',
      'the escalator',
      'the lift'
    ],
    [
      ' ',
      ', seejärel ',
      ' ja ',
      ' %S lähedal',
      ' kasutades ',
      'treppi',
      'eskalaatorit',
      'lifti'
    ],
    [
      ' ',
      ', sitten ',
      ' ja ',
      ' %S:n lähellä',
      ' käyttäen ',
      'rappusia',
      'rullaportaita',
      'hissiä'
    ],
    [
      ' for ',
      ' deretter ',
      ' og ',
      ' nær %S',
      ' ved hjelp av ',
      'trappen',
      'rulletrappen',
      'heisen'
    ],
    [
      ' för ',
      ' och ',
      ' och ',
      ' nära %S',
      ' genom att använda ',
      'trappan',
      'rulltrappan',
      'hissen'
    ],
    [
      ' ',
      ', затем ',
      ' и ',
      ' рядом с %S',
      ' используя ',
      'лестницу',
      'эскалатор',
      'лифт'
    ]
  ];
};

module.exports = { addTranslations };
